import { Nullable } from "@tager/admin-services";

import { ProductGroupType } from "@/typings/model";
import {
  ProductGroupCreationPayload,
  ProductGroupUpdatePayload,
} from "@/services/requests";

export type FormValues = {
  name: string;
  systemName: string;
};

export function convertProductGroupToFormValues(
  productGroup: Nullable<ProductGroupType>
): FormValues {
  if (!productGroup) {
    return {
      name: "",
      systemName: "",
    };
  }
  return {
    name: productGroup.name ?? "",
    systemName: productGroup.systemName ?? "",
  };
}

export function convertFormValuesToProductGroupCreationPayload(
  values: FormValues
): ProductGroupCreationPayload {
  return {
    name: values.name ?? "",
    systemName: values.systemName ?? "",
  };
}

export function convertFormValuesToProductGroupUpdatePayload(
  values: FormValues
): ProductGroupUpdatePayload {
  return {
    ...convertFormValuesToProductGroupCreationPayload(values),
  };
}
